import { isBefore, isWithinInterval, differenceInMinutes } from 'date-fns';
import _head from 'lodash/head';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import { OPENING_SOON_STATUS, OPEN_STATUS, CLOSING_SOON_STATUS, CLOSED_STATUS, hourLabelToPriorityMap } from './StatusLabel.constants';
import { OPENING_SOON_MINUTE_THRESHOLD, CLOSING_SOON_MINUTE_THRESHOLD } from '../../HoursOfOperation.constants';
import { hourOfOperationToOpenAndCloseDate } from '../../HoursOfOperation.utils';
export function getHourStatus(hour, now, timezone) {
  var _ref = hour || {},
    open = _ref.open,
    close = _ref.close;
  if (_isNil(open) || _isNil(close)) {
    return null;
  }
  var _hourOfOperationToOpe = hourOfOperationToOpenAndCloseDate(hour, timezone, now),
    openMoment = _hourOfOperationToOpe.openMoment,
    closeMoment = _hourOfOperationToOpe.closeMoment;
  var hourStatus = CLOSED_STATUS;
  if (isBefore(now, openMoment)) {
    var openingSoonDifference = differenceInMinutes(openMoment, now);
    if (openingSoonDifference >= 0 && openingSoonDifference <= OPENING_SOON_MINUTE_THRESHOLD) {
      hourStatus = OPENING_SOON_STATUS;
    }
  }
  if (isWithinInterval(now, {
    start: openMoment,
    end: closeMoment
  }) && isBefore(now, closeMoment)) {
    // Normal range check using an inclusive start time and exclusive end time
    hourStatus = OPEN_STATUS;
  }
  if (hourStatus === OPEN_STATUS && Math.abs(differenceInMinutes(closeMoment, now)) <= CLOSING_SOON_MINUTE_THRESHOLD) {
    hourStatus = CLOSING_SOON_STATUS;
  }
  return hourStatus;
}
export function getAllHourStatus(hours, now, timezone) {
  return hours.map(function (hour) {
    return getHourStatus(hour, now, timezone);
  }).filter(Boolean);
}
export function getHighestPriorityHourStatus(hourStatuses) {
  if (_isNil(hourStatuses)) {
    return null;
  }
  var validHourStatuses = hourStatuses.filter(function (status) {
    return Object.keys(hourLabelToPriorityMap).includes(status);
  });
  if (_isEmpty(validHourStatuses)) {
    return null;
  }
  var hourStatusSortedByPriority = validHourStatuses.sort(function (a, b) {
    return hourLabelToPriorityMap[a] - hourLabelToPriorityMap[b];
  });
  return _head(hourStatusSortedByPriority);
}